module.exports = __webpack_public_path__ + "static/img/es.dae16f90.svg";